export const sampleEvents = [
  {
    id: "1",
    title: "Emergency Cooling Centers Open",
    description:
      "Due to extreme heat conditions in our area, the municipality has opened emergency cooling centers to provide residents with a safe, air-conditioned environment. These centers are free and open to all residents seeking relief from the heat.",
    typeCode: "COMMERCIAL",
    typeName: "Commercial",
    date: "2025-12-28",
    time: "14:00",
    location: "Downtown Community Center",
    attachments: [
      { id: "file-1", name: "CoolingCenterInfo.pdf", url: "#" },
      { id: "file-2", name: "VolunteerBrief.docx", url: "#" },
    ],
    resourceRequirements: "Tables, chairs, first-aid kit",
    needVolunteers: true,
    inviteNgoMunicipality: true,
    roles: [
      {
        id: "role-1",
        roleName: "TRANSPORTATION",
        label: "Transportation",
        countNeeded: 2,
        specialRequirements: "Valid driver's license and availability for two shifts.",
      },
      {
        id: "role-2",
        roleName: "FOOD_SUPPLIES",
        label: "Food Supplies",
        countNeeded: 3,
        specialRequirements: "Experience in food distribution preferred.",
      },
    ],
    createdAt: "2025-10-28T09:30:00.000Z",
    updatedAt: "2025-10-28T11:00:00.000Z",
  },
  {
    id: "2",
    title: "Community Health Fair",
    description:
      "A collaborative effort to provide free health screenings and wellness resources for residents.",
    typeCode: "RESIDENTIAL",
    typeName: "Residential",
    date: "2025-11-15",
    time: "10:30",
    location: "Sector 12 Community Plaza",
    attachments: [{ id: "file-3", name: "EventSchedule.pdf", url: "#" }],
    resourceRequirements: "Portable tents, signage, registration tables",
    needVolunteers: false,
    inviteNgoMunicipality: false,
    roles: [],
    createdAt: "2025-10-02T14:45:00.000Z",
    updatedAt: "2025-10-12T16:10:00.000Z",
  },
  {
    id: "3",
    title: "Riverfront Cleanup Drive",
    description:
      "Join us to restore the riverfront by removing debris and planting native vegetation.",
    typeCode: "COMMERCIAL",
    typeName: "Commercial",
    date: "2025-08-20",
    time: "08:00",
    location: "Riverside Park Entrance",
    attachments: [],
    resourceRequirements: "Trash bags, gloves, safety signage",
    needVolunteers: true,
    inviteNgoMunicipality: false,
    roles: [
      {
        id: "role-3",
        roleName: "TRANSPORTATION",
        label: "Transportation",
        countNeeded: 1,
        specialRequirements: "Pickup truck for moving collected debris.",
      },
    ],
    createdAt: "2025-07-25T08:20:00.000Z",
    updatedAt: "2025-07-30T09:00:00.000Z",
  },
];
